// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-landing-tsx": () => import("./../src/templates/landing.tsx" /* webpackChunkName: "component---src-templates-landing-tsx" */)
}

